module.exports = __webpack_public_path__ + "img/share-facebook.83db00cd.svg";